import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'
import App from './App';
import { AuthProvider } from './context/Auth/AuthContext';


ReactDOM.render(
  <React.StrictMode>
    <AuthProvider> {/* Envolvendo o App com o contexto global de autenticação */}
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
